<template>
  <b-row>
    <b-col md="12">

      <!-- Alert: No item found -->
      <b-alert
        variant="danger"
        :show="errorMessage !== ''"
      >
        <h4 class="alert-heading">
          {{ errorMessage }}
        </h4>

      </b-alert>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class=""
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            :name="$t('Chọn thiết bị ')"
            rules="required"
          >
            <b-form-group label-for="series_id">
              <template #label>
                <label class="d-block font-weight-bolder">Chọn Thiết bị <span class="text-danger">*</span></label>
              </template>
              <v-select
                v-model="itemData.device_id"
                :options="dataDevice"
                :reduce="(val) => val.id"
                label="name"
                placeholder="--Chọn--"
                @input="changeDevice($event)"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Chon series -->
          <validation-provider
            #default="validationContext"
            :name="$t('Chọn series ')"
            rules="required"
          >
            <b-form-group label-for="series_id">
              <template #label>
                <label class="d-block font-weight-bolder">Chọn series <span class="text-danger">*</span></label>
              </template>
              <v-select
                v-model="itemData.series_ids"
                :options="dataSeries"
                :reduce="(val) => val.id"
                label="name"
                multiple
                placeholder="--Chọn--"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!--  Nội dung -->
          <validation-provider
            #default="validationContext"
            :name="$t('Nội dung sửa')"
            rules="required"
          >
            <b-form-group
              :label="$t('Nội dung')"
              label-for="title"
            >
              <template #label>
                <label class="d-block font-weight-bolder">Nội dung sửa <span class="text-danger">*</span></label>
              </template>
              <b-form-textarea
                id="content"
                v-model="itemData.content"
                :state="getValidationState(validationContext)"
                rows="3"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            :name="$t('Đơn vị sửa')"
            rules="required"
          >
            <b-form-group
              :label="$t('Đơn vị sửa')"
              label-for="title"
            >
              <template #label>
                <label class="d-block font-weight-bolder">Đơn vị sửa <span class="text-danger">*</span></label>
              </template>
              <b-form-textarea
                id="repair_unit"
                v-model="itemData.repair_unit"
                :state="getValidationState(validationContext)"
                rows="3"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- <div
            v-for="(item) in dataForms"
            :key="item.id"
          >
            <b-form-group v-if="item.type === 'number'">
              <template #label>
                <label class="d-block font-weight-bolder">{{ item.field }} </label>
              </template>
              <b-form-input
                v-model="item.value"
                type="number"
                trim
              />
            </b-form-group>
            <b-form-group v-if="item.type === 'text'">
              <template #label>
                <label class="d-block font-weight-bolder">{{ item.field }} </label>
              </template>
              <b-form-input
                v-model="item.value"
                type="text"
                trim
              />
            </b-form-group>
            <b-form-group v-if="item.type === 'date'">
              <template #label>
                <label class="d-block font-weight-bolder">{{ item.field }}</label>
              </template>
              <flat-pickr
                v-model="item.value"
                class="form-control"
                :config="configDate"
                placeholder="dd-mm-yyyy"
              />
            </b-form-group>
          </div> -->

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >

              <span>{{ $t('Save') }}</span>
            </b-button>
          </div>

        </b-form>
      </validation-observer>

    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BAlert, BForm, BFormGroup, BButton, BFormInvalidFeedback, BFormTextarea, BFormInput,
} from 'bootstrap-vue'
import {
  ref,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNumDot, max,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import vSelect from 'vue-select'
import moment from 'moment'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BForm,
    BFormGroup,
    BButton,
    BFormTextarea,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    vSelect,
    BFormInput,
  },
  directives: {
    Ripple,
  },
  props: {
    mdata: Object,
  },
  data() {
    return {
      required,
      alphaNumDot,
      max,
      dataManufacture: [],
      dataSeries: [],

    }
  },
  computed: {

  },
  mounted() {
  },

  setup(props, { emit }) {
    const { route, router } = useRouter();
    const id = 0;
    const errorMessage = ref('')
    const dataDevice = ref([])
    const dataFields = ref([])
    const defaultItemData = {
      content: '',
      repair_unit: '',
      device_id: '',
      series_ids: [],
      data_fields: [],

    }
    const dataForms = ref([])
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)));
    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)

    const getAllDevice = () => {
      store.dispatch('device/fetchAllSeriesNotUse', { isPaginate: 0 })
        .then(response => {
          const result = response.data
          if (result.code === 200) {
            // dataSeries.value = result.data.details.map(o => ({
            //   name: o.series_name,
            //   id: o.series_id,
            // }));

            dataDevice.value = result.data;
          }
        })
        .catch(error => {
          // console.log('error', error)
        })
    }
    getAllDevice()
    const getFormSetting = () => {
      store.dispatch('device/getFormSetting')
        .then(response => {
          if (response.data.code === 200) {
            const rslt = response.data.data;
            if (rslt.length > 0) {
              dataForms.value = rslt;
            }
          }
        })
    }
    getFormSetting()
    const onSubmit = () => {
      errorMessage.value = '';
      (itemData.value.data_fields = dataForms);
      store.dispatch('device/createRepair', { data: itemData.value })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.code === 200) {
              showToast(response.data.message, { variant: 'success' });
              resetForm()
              emit('updateData')
            } else {
              showToast(response.data.message)
              errorMessage.value = response.data.message;
            }
          }
        })
    }

    const configDate = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    return {
      id,
      errorMessage,
      itemData,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      configDate,
      dataDevice,
      dataForms,
      dataFields,
      // dataSeries,
    }
  },
  methods: {
    changeDevice(event) {
      const rslt = this.dataDevice.find(o => o.id === event);
      this.dataSeries = [];
      this.itemData.series_ids = []
      if (rslt) {
        this.dataSeries = rslt.series_not_use.map(o => ({
          name: o.name,
          id: o.id,
        }));
      }
    },
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
